export const AUDIT_LOGS_LIMIT = 50;

export const ENV_SET_ACTION = 'ENV_SET';
export const ENV_DELETE_ACTION = 'ENV_DELETE';

export const VERSION_ADDED_ACTION = 'version added';
export const VERSION_DELETED_ACTION = 'version deleted';
export const VERSION_CHANGED_ACTION = 'version changed';
export const VERSION_BLOCKED_ACTION = 'version blocked';
